import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { WhatsAppConversation } from "../../aiConversations.types";
import {
  AiConversationSubRoute,
  ApiRoutesAiConversations
} from "../../constants/enums";
import { SetConversationModeRequestBody } from "./setConversationMode.types";

export const requestSetConversationMode = async ({
  conversationId,
  mode
}: SetConversationModeRequestBody): Promise<WhatsAppConversation> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesAiConversations.Conversations,
      conversationId,
      AiConversationSubRoute.Mode
    ),
    { mode }
  );
};
